import { FeeDefinition, FieldType } from '@pmp/api';
import { ValueList } from '@ohpen/enso-ui';

export const FEES_VALUE_LIST_NAMES: FieldType[] = [
  FieldType.FEE_TYPE,
  FieldType.CALCULATION_TYPE,
  FieldType.PRODUCT_FEE_BASED_ON,
  FieldType.PAYMENT_METHOD,
  FieldType.PAYMENT_STAGE,
  FieldType.YES_NO,
];

export const FEES_ENTITY_LIST_NAMES: FieldType[] = [FieldType.FEES];

export const getFeeOptions = (feesResult: FeeDefinition[]): ValueList =>
  feesResult.reduce((acc: ValueList, fee: FeeDefinition) => ({ ...acc, [fee.feeId]: fee.feeName ?? fee.feeId }), {} as ValueList);
